export default __webpack_public_path__ + "static/media/DNo.30-0.afa42498.jpg";